module.exports = __webpack_public_path__ + "static/media/1f3e6.17cc228b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f3e6.svg
// module id = 641
// module chunks = 1